export class ConvenioCartaoAutenticarFormModel {
    constructor(
        public numeroCartao?: string,
        public senha?: string,
        public cpfcnpj?: string,
    ) { }
}
